import { connect } from 'react-redux'
import SearchTypeButton from 'components/search/SearchTypeButton'
import { setSignUpModalIsOpen } from 'redux/actions'

const mapStateToProps = state => ({
  query: state.search.query,
  flavour: state.layout.flavour,
  isLogged: state.user.isLogged,
  smartSearch: state.search.smartSearchEnabled
})

const mapDispatchToProps = dispatch => ({
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(SearchTypeButton)
